import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import { commandWorkspacePluginCollaboratorSummary } from '../actions';
import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { accountOrTeamId, pluginId, collaboratorType } = action;

  const workspacePluginPermissionRevoke = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_WORKSPACE_PLUGIN_PERMISSION_REVOKE,
    [`${collaboratorType}Id`]: accountOrTeamId,
    pluginId,
  });

  if (workspacePluginPermissionRevoke.type === constants.RTM_WORKSPACE_PLUGIN_PERMISSION_REVOKE_OK) {
    yield put(commandWorkspacePluginCollaboratorSummary(pluginId));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: workspacePluginPermissionRevoke.message || <FormattedMessage {...messages.permissionRevokeError} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_PLUGIN_PERMISSION_REVOKE, catchErrors, sendRequest, connection);
}
